"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _TextField = _interopRequireDefault(require("@sprinx/react-mui-fields/TextField"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _useAppSettingsAgreementFieldComponents = _interopRequireDefault(require("../../../app/AppSettingsProvider/useAppSettingsAgreementFieldComponents"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {},
      form: {},
      buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
      }
    }
  );
}, {
  name: 'ProductDetailQuestionForm'
});

function ProductDetailQuestionForm(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      errors = _ref.errors,
      isSubmitting = _ref.isSubmitting,
      handleChange = _ref.onChange,
      handleSubmit = _ref.onSubmit,
      values = _ref.values,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "errors", "isSubmitting", "onChange", "onSubmit", "values"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var _useAppSettingsAgreem = (0, _useAppSettingsAgreementFieldComponents.default)(),
      AgreementFieldProductGdprComponent = _useAppSettingsAgreem.AgreementFieldProductGdprComponent;

  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    className: (0, _clsx.default)(classes.form, className)
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    type: "text",
    name: "firstName",
    id: "firstName",
    label: t('productQuestion/firstName'),
    value: values.firstName,
    onChange: handleChange('firstName'),
    error: errors.firstName,
    fullWidth: true,
    variant: 'filled',
    required: true
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    type: "text",
    name: "lastName",
    id: "lastName",
    label: t('productQuestion/lastName'),
    value: values.lastName,
    onChange: handleChange('lastName'),
    error: errors.lastName,
    fullWidth: true,
    variant: 'filled',
    required: true
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    type: "email",
    name: "email",
    id: "email",
    label: t('productQuestion/email'),
    value: values.email,
    onChange: handleChange('email'),
    error: errors.email,
    fullWidth: true,
    variant: 'filled',
    required: true
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    type: "text",
    name: "subject",
    id: "subject",
    label: t('productQuestion/subject'),
    value: values.subject,
    onChange: handleChange('subject'),
    error: errors.subject,
    variant: 'filled',
    fullWidth: true,
    disabled: true
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    type: "text",
    name: "question",
    id: "question",
    label: t('productQuestion/question'),
    value: values.question,
    onChange: handleChange('question'),
    error: errors.question,
    multiline: true,
    rows: 8,
    fullWidth: true,
    variant: 'filled',
    required: true
  }), /*#__PURE__*/_react.default.createElement(AgreementFieldProductGdprComponent, {
    onChange: handleChange('gdpr'),
    value: values.gdpr,
    error: errors.gdpr
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "submit",
    variant: "outlined",
    color: "primary",
    disabled: isSubmitting
  }, t('productQuestion/button')))));
}

process.env.NODE_ENV !== "production" ? ProductDetailQuestionForm.propTypes = {
  classes: _propTypes.default.shape({
    buttonContainer: _propTypes.default.string,
    form: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  errors: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    email: _propTypes.default.string,
    firstName: _propTypes.default.string,
    gdpr: _propTypes.default.bool,
    lastName: _propTypes.default.string,
    question: _propTypes.default.string,
    subject: _propTypes.default.string
  })]),
  isSubmitting: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  values: _propTypes.default.shape({
    email: _propTypes.default.string,
    firstName: _propTypes.default.string,
    gdpr: _propTypes.default.bool,
    lastName: _propTypes.default.string,
    question: _propTypes.default.string,
    subject: _propTypes.default.string
  })
} : void 0;
ProductDetailQuestionForm.defaultProps = {
  classes: undefined,
  className: undefined,
  errors: undefined,
  isSubmitting: undefined,
  onChange: undefined,
  onSubmit: undefined,
  values: undefined
};
var _default = ProductDetailQuestionForm;
exports.default = _default;